export default {
    ren: 'Orang',
    jiangong: 'Item, total',
    dingdanjine: 'Jumlah Perintah',
    bubaohandandu: 'Jumlah ini tidak termasuk jumlah untuk produk bantuan yang dibeli secara terpisah',
    shijizhifu: 'Pembayaran Sebenarnya',
    yincangquanbu: 'Sembunyikan Semua',
    zhankaiquanbu: 'Mengembangkan Semua',
    dingdanxiangqing: 'Perintah Rincian',
    yizhifu: 'Sudah dibayar',
    caozuo: 'Operasi',
    dingdanchuangjianshijian: 'Tarikh penciptaan perintah',
    ewaixingli: 'Beli bagasi tambahan',
    tianjiaxingli: 'Tambah Layanan Bagasi',
    zanweigoumaifuyingchanpin: "Aku belum membeli produk bantuan.",
    xinglixinxi: 'Informasi Bagasi',
    buxuyao: 'Tidak Perlu',
    suoyouchengke: 'Semua Penumpang',
    weisuoyouchengkegoumai: 'Pembelian bersatu untuk semua penumpang',
    weisuoyouchengkedandugoumai: 'Beli secara terpisah untuk setiap penumpang',
    qucheng: 'Perjalanan',
    huicheng: 'Perjalanan kembali',
    fujiafuwu: 'Fitur Tambah',
    xinglizonge: 'Total Harga Bagasi'
};